import "./index.css";

import { CssBaseline, ThemeProvider } from "@mui/material";
import axios from "axios";
import { useEffect, useMemo } from "react";
import ReactDOM from "react-dom/client";
import { useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { persistor, store } from "./redux/Store";
import { makeTheme } from "./theme";

axios.defaults.withCredentials = true;

function Root() {
  const { i18n } = useTranslation();
  const direction = i18n.dir();
  const isRTL = direction === "rtl";

  const theme = useMemo(() => makeTheme(i18n.language, isRTL), [i18n.language, isRTL]);

  useEffect(() => {
    document.documentElement.dir = direction;
    document.body.dir = direction;
    const [langBase] = i18n.language.split("-");
    document.documentElement.lang = langBase || (isRTL ? "ar" : "en");
  }, [direction, i18n.language, isRTL]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
